; if (!$$sfTypekit) {
	var $$sfTypekit = 'nev2fdr';
}

$$ash.getTypeKit($$sfTypekit); //typekit id passed to async call to typekit script

var $$siteSettings = {
	name: 'Silver&Fit',
	url: 'https://www.silverandfit.com',
	fbAppId: '1550874695156702',
	fbNamespace: 'silverandfit'
};

(function ($$ashChartOpts, $, undefined) { //ASHCHART OPTIONS
	var donut, chart, arc, tempOpts,
		s = { //default values
			fontFam: "'franklin-gothic-urw', 'sans-serif'",
			fontColor: '#ffffff',
			fillColor: '#006E83',
			secondaryFillColor: '#72cdc4', //in this case, self-measured steps
			bgColor: '#D8EDEE'
		},
		opts = [
			$$ashChartOpts.donut = $.extend({}, s),
			$$ashChartOpts.chart = $.extend({}, s),
			$$ashChartOpts.arc = $.extend({}, s)
		];

	//option to override default settings above
	donut = {
		gap: false,
		fontColor: s.fillColor
	};
	chart = {
		fontColor: '#000',
		bgColor: '#F9F9F9'
	};
	arc = {
		fillColor: '#6FA9D7',
		bgColor: '#D6D6D6'
	};
	//end override options

	tempOpts = [donut, chart, arc];

	for (var i in opts) {
		if (opts.hasOwnProperty(i)) {
			$.extend(opts[i], tempOpts[i]);
		}
	}
}(window.$$ashChartOpts = window.$$ashChartOpts || {}, jQuery));

function progressBarSizing() {
	if ($('.oldie .progress-bar').length) {
		$('.progress-bar').equalColumnWidth();
	}
	else if (Modernizr.mq($$ash.mq('xs', 'min'))) {
		$('.progress-bar').equalColumnWidth();
	}
	else {
		$('.progress-bar .progress-nodes > li').width('100%');
	}
}

$(document).ready(function () {
	var body = $('body');
	$$ash.removeSelectEmptyOption();

	//initialize session timer
	if (document.querySelectorAll('.isHome').length === 0) {
		$$ash.sessionTimerInit({
			delayMins: $$sessionTimeOut,
			countSecs: 30
		});
	}

	//collapsible-panel for landing page
	$('.collapsible-cont .collapsible-header').ashCollapsible({
		panel: $('.collapsible-cont .collapsible-body'),
		keepOpenWidth: 0
	});

	if ($('table.accordion')) {
		$('table.accordion tr').ashAccord({
			trigger: '.expand', //ele that triggers the accordion
			content: '.hidden'
		});
	}

	navigation();
	$$ash.metaNavInit(
		'.secondaryInfo .user-info a.dropdown-menu-trigger',
		'.secondaryInfo .user-info .dropdown-menu-cont'
	);

	//Preferences Filter
	if ($('.accntPrefFilter').length) {
		$('.accntPrefFilter').each(function () {
			var ashTrig = $(this);
			ashTrig.ashFilter({
				event: 'change',
				trigger: $(this).find('input'),
				filterItem: $('.ashFilter'),
				fadeInDur: 1,
				fadeOutDur: 0
			});
		});
	}

	setupAshModal($('.modalOpen'));


	if ($('.flexslider').length) {
		if ($('.widget-slide').length) {
			(function widgetSliderInit() {
				var slideshow = $('.widget-slide');

				slideshow.flexslider({ //ASHCo Careers Benefits & ASHCo Solutions and Services
					selector: '.ashslide-reel .ashslide-slide', //**NOTE TO UI: Update ashslide-* class names to carousel-* once markup is updated by programmers
					animation: 'slide',
					slideshow: false,
					controlNav: false,
					prevText: '<span class="icon-rotateLeft" aria-hidden="true"></span>',
					nextText: '<span class="icon-rotateRight" aria-hidden="true"></span>',
				});
			})();
		}
	}

	function disableDefaultOption(dOpt) { //diable options in select2 dropdowns
		dOpt.on('click', function () {
			$(dOpt.find('option')).each(function () {
				var opt = $(this);
				if (opt.val() === '') {
					opt.prop('disabled', true);
				}
			});
			dOpt.off('click'); //kill disabling function once the option is used
		});
	}
	$('.ashFilterTrigger').each(function () {
		var obj = $(this);

		if (!obj.hasClass('label_group')) { //fixing conflict with challenge ashFilterTrigger
			obj.ashFilter({
				event: 'change',
				trigger: $(this),
				filterItem: $('.ashFilter'),
				addSelected: 'selected',
				fadeInDur: 1,
				fadeOutDur: 0
			});

			//setup disable option
			disableDefaultOption(obj);
		}
	});

	function selectPopulateDropdown(elemID, select2) { //populate a related dropdown
		var trigger = $('.select2.ashFilterTrigger'),
			elemOpt = $(elemID + ' option'),
			inquiryOpt = elemOpt.detach(), //remove and store all options in 2nd select
			elemEvent = (select2) ? 'select2-close' : 'change',
			elemVal = '',
			newOpt;

		function buildOpts(obj, newOpt) {
			//Remove all 2nd selects options
			elemOpt.remove();

			//loop thru each option and append those whose filter = its tag
			obj.each(function () {
				var selObj = $(this);
				if (selObj.data('ash-filter') === undefined || selObj.data('ash-filter').indexOf(newOpt) > -1) {
					selObj.appendTo(elemID);
				}
			});
			$(elemID + ' option:first-child').prop('selected', true);
		}

		if (trigger.length !== 0) {
			//disable the inquiry type dropdown
			$(elemID).prop('disabled', true);

			trigger.on(elemEvent, function () {
				elemVal = (select2) ? $(this).select2('val') : $(this).val();
				newOpt = $('select.ashFilterTrigger option[value="' + elemVal + '"]').data('ash-filter-trigger');  //get filter tag

				//enable the inquiry type dropdown and setup validation
				$(elemID).prop('disabled', false);

				//run build options function
				buildOpts(inquiryOpt, newOpt);

				//setup disable option
				disableDefaultOption($(elemID));
			});
		} else {
			newOpt = $(elemID).data('ash-filter-default');
			//run build options function
			buildOpts(inquiryOpt, newOpt);
		}
	}

	selectPopulateDropdown('#inquiryType', false); //populating drop down no select 2
	$$ash.removeSelectEmptyOption();


	//collapsible-panel for FAQ page
	$('.collapsible-faq dt').ashCollapsible();

	//main list items in component nav
	$('ul.component-nav > li').each(function () {
		var obj = $(this); //category item

		obj.on('click', function () {
			$(this).parent().find('li').removeClass('selected');
			$(this).addClass('selected');
		});
	});
	//eCoaching classes
	$('.tabsFilter').each(function () {
		var ashTrig = $(this);
		ashTrig.ashFilter({
			event: 'click',
			trigger: $(this).find('li > a'),
			filterItem: $('.ashFilter'),
			fadeInDur: 1,
			fadeOutDur: 0
		});
	});
	//calling ashmodal on the video link and loading the ashmodal on the page containing the vimeo
	//the callback will trigger callBackModalEmbed which communicates the embeded video (using Froogaloop.js)
	//using iframe.load to ensure video is loaded first before calling play
	if ($('.autoPlayVidEmbed').length) {
		$('.autoPlayVidEmbed').ashModal({
			'removePageScroll': true,
			'closeContent': '<span class="icon-closeExit" aria-hidden="true"></span>',
			'callbackAfterClick': callBackModalEmbed,
			'theContent': $('.ashModalCont[data-ash-ashmodalmatch="' + $('.autoPlayVidEmbed').attr('data-ash-ashmodalmatch') + '"]')
		});
	}
	function callBackModalEmbed() {
		//#fitnessIsTimeless is the video id
		var iframe = $('#fitnessIsTimeless')[0],
			player = $f(iframe);

		//make sure iframe is loaded before calling it then use callbackfunction
		$('iframe').load(callbackIframe);
		function callbackIframe() {
			var fitnessVideo = $('iframe#fitnessIsTimeless');
			// Call the API when a button is pressed and attach a trigger so video plays automatically
			fitnessVideo.on('click', function () {
				player.api('play');
			});
			fitnessVideo.trigger('click');
		}
	}

	//add box shadow to header when users scrolls from the top of the page
	if (body.hasClass('isHome')) {
		(function initToggleHeaderShadow() {
			var header = $('header'),
				shadowClass = 'hasShadow';

			function toggleHeaderShadow() {
				var currentPosition = $(window).scrollTop();

				if (currentPosition > 0) {
					header.addClass(shadowClass);
				} else {
					header.removeClass(shadowClass);
				}
			}

			$$ash.scrollThrottle(toggleHeaderShadow, 250, 'scroll.toggleHeaderShadow orientationchange.toggleHeaderShadow');
		})();
	}
}); //END DOCUMENT READY

$(window).on('resize load', function () {


	//SF PROGRESS BAR
	progressBarSizing();
	//close device message in the marketplace
	$('body').on('click', '.closeDeviceMsg', function (e) {
		e.preventDefault();
		$(this).closest('.ashModal').find('.ashModalClose').trigger('click');
		window.location.href = $(e.target).attr('href');
	});
});